<div class="model-content bg-secondary">
    <div class="madel-header ">
        <h3 mat-dialog-title class="model-title">Test Results</h3>
    </div>
    <div>
        <button class="close" mat-button (click)="onNoClick()">X</button>
    </div>
</div>
<!-- MPC MARKS LIST -->

<div class="p-2" *ngIf="mpcshow">
    <form class="example-form">
        <form [formGroup]="mpcForm">
            <div>
                <div class="test" *ngIf="data">
                    <div class="test_code">
                        <h4 class="test_title">Test Code</h4>
                        <h4 class="test_data">{{data.testCode}}</h4>
                    </div>
                    <div class="test_date">
                        <h4 class="test_title">Test Date</h4>
                        <h4 class="test_data">{{data.testDate}}</h4>
                    </div>
                </div>
                <h3 class="subject">
                    Subject Details
                </h3>

                <ng-container *ngIf="data">
                    <div>
                        <div class="all_list">
                            <div class="all_list_grid">
                                <label for="" class="marks_label">Subjects</label>
                                <label for="" class="marks_label">Marks</label>
                                <label for="" class="marks_label">Max Marks</label>
                                <label for="" class="marks_label">Topper Marks</label>
                                <label for="" class="marks_label">Average Marks</label>

                                <h6 class="marks_name">Maths</h6>
                                <h6 class="marks_maths">{{data.maths}}</h6>
                                <h6 class="marks_maxmarks">{{data.mathMaxMarks}}</h6>
                                <h6 class="marks_top">{{data.topMaths}}</h6>
                                <h6 class="marks_avgmarks">{{data.avgMaths}}</h6>

                                <h6 class="marks_name">Physics</h6>
                                <h6 class="marks_maths">{{data.physics}}</h6>
                                <h6 class="marks_maxmarks">{{data.phyMaxMarks}}</h6>
                                <h6 class="marks_top">{{data.topPhy}}</h6>
                                <h6 class="marks_avgmarks">{{data.avgPhy}}</h6>

                                <h6 class="marks_name">Chemistry</h6>
                                <h6 class="marks_maths">{{data.chemistry}}</h6>
                                <h6 class="marks_maxmarks">{{data.cheMaxMarks}}</h6>
                                <h6 class="marks_top">{{data.topChem}}</h6>
                                <h6 class="marks_avgmarks">{{data.avgChem}}</h6>
                            </div>
                        </div>
                    </div>
                    <h3 class="rank_details">
                        Rank Details
                    </h3>
                    <div>
                        <div class="all_list">
                            <div class="all_ranks_grid">
                                <label for="" class="marks_label">Maths </label>
                                <label for="" class="marks_label">Physics </label>
                                <label for="" class="marks_label">Chemistry </label>
                                <label for="" class="marks_label">Section </label>
                                <label for="" class="marks_label">Campus </label>
                                <label for="" class="marks_label">State </label>

                                <h6 class="marks_text">{{data.mRank}}</h6>
                                <h6 class="marks_text">{{data.pRank}}</h6>
                                <h6 class="marks_text">{{data.cRank}}</h6>
                                <h6 class="marks_text">{{data.secRank}}</h6>
                                <h6 class="marks_text">{{data.campusRank}}</h6>
                                <h6 class="marks_text">{{data.stateRank}}</h6>

                            </div>
                        </div>
                        <div class="all_list">
                            <div class="all_state_grid">
                                <!-- <label for="" class="marks_label">State </label>
                                <h6 class="marks_text">{{data.stateRank}}</h6> -->
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </form>
    </form>
</div>

<!-- BIPC MARKS LIST -->

<div class="p-2" *ngIf="bipcshow">
    <form class="example-form">
        <form [formGroup]="bipcForm">
            <div>
                <div class="test" *ngIf="data">
                    <div class="test_code">
                        <h4 class="test_title">Test Code</h4>
                        <h4 class="test_data">{{data.testCode}}</h4>
                    </div>
                    <div class="test_date">
                        <h4 class="test_title">Test Date</h4>
                        <h4 class="test_data">{{data.testDate}}</h4>
                    </div>
                </div>
                <h3 class="subject">
                    Subjects Details
                </h3>
                <ng-container *ngIf="data">
                    <div>
                        <div class="all_list">
                            <div class="all_list_grid">
                                <label for="" class="marks_label">Subjects</label>
                                <label for="" class="marks_label">Marks</label>
                                <label for="" class="marks_label">Max Marks</label>
                                <label for="" class="marks_label">Topper Marks</label>
                                <label for="" class="marks_label">Average Marks</label>

                                <h6 class="marks_name">Physics</h6>
                                <h6 class="marks_maths">{{data.physics}}</h6>
                                <h6 class="marks_maxmarks">{{data.phyMaxMarks}}</h6>
                                <h6 class="marks_top">{{data.topPhy}}</h6>
                                <h6 class="marks_avgmarks">{{data.avgPhy}}</h6>

                                <h6 class="marks_name">Chemistry</h6>
                                <h6 class="marks_maths">{{data.chemistry}}</h6>
                                <h6 class="marks_maxmarks">{{data.cheMaxMarks}}</h6>
                                <h6 class="marks_top">{{data.topChem}}</h6>
                                <h6 class="marks_avgmarks">{{data.avgChem}}</h6>

                                <h6 class="marks_name">Botany</h6>
                                <h6 class="marks_maths">{{data.botany}}</h6>
                                <h6 class="marks_maxmarks">{{data.botMaxMarks}}</h6>
                                <h6 class="marks_top">{{data.topBot}}</h6>
                                <h6 class="marks_avgmarks">{{data.avgBot}}</h6>

                                <h6 class="marks_name">Zoology</h6>
                                <h6 class="marks_maths">{{data.zoology}}</h6>
                                <h6 class="marks_maxmarks">{{data.zooMaxMarks}}</h6>
                                <h6 class="marks_top">{{data.topZoo}}</h6>
                                <h6 class="marks_avgmarks">{{data.avgZoo}}</h6>
                            </div>
                        </div>
                    </div>



                    <h3 class="rank_details">
                        Ranks Details
                    </h3>
                    <div>
                        <div class="all_list">
                            <div class="all_ranks_grid">
                                <label for="" class="marks_label">Physics</label>
                                <label for="" class="marks_label">Chemistry</label>
                                <label for="" class="marks_label">Botany</label>
                                <label for="" class="marks_label">Zoology</label>
                                <label for="" class="marks_label">Section</label>
                                <label for="" class="marks_label">Campus</label>

                                <h6 class="marks_text">{{data.pRank}}</h6>
                                <h6 class="marks_text">{{data.cRank}}</h6>
                                <h6 class="marks_text">{{data.bRank}}</h6>
                                <h6 class="marks_text">{{data.zRank}}</h6>
                                <h6 class="marks_text">{{data.secRank}}</h6>
                                <h6 class="marks_text">{{data.campusRank}}</h6>

                            </div>
                        </div>
                        <div class="all_list">
                            <div class="all_state_grid">
                                <label for="" class="marks_label">State</label>
                                <h6 class="marks_text">{{data.stateRank}}</h6>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </form>
    </form>
</div>


<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>